import { PhoneIcon } from "@heroicons/react/24/outline";
import { formatPhoneNumber } from "@sp-crm/core";
import React from "react";
import { EntityActivitySummary } from "./details/entity-activity-summary";
import { EntityActivityEntryProps } from "./types";

export const EntityActivityVoiceCall: React.FC<EntityActivityEntryProps> = props => {
    const { activity } = props;
    const outgoingCallEvent = activity.activity.metadata?.events?.find(
        e => e.type === "OutgoingCall",
    );
    const phoneNumber = outgoingCallEvent?.outgoingCall?.phoneNumber;
    const formattedPhoneNumber = phoneNumber ? formatPhoneNumber(phoneNumber) : null;

    return (
        <div className="relative flex items-start space-x-3">
            <div className="relative px-1">
                <div className="flex h-8 w-8 items-center justify-center rounded-full bg-gray-100 ring-8 ring-white">
                    <PhoneIcon className="h-5 w-5 text-gray-500" aria-hidden="true" />
                </div>
            </div>
            <div className="min-w-0 flex-1 group pt-1">
                <EntityActivitySummary {...props}>
                    placed a call
                    {formattedPhoneNumber ? (
                        <>
                            {" "}
                            to <strong>{formattedPhoneNumber}</strong>
                        </>
                    ) : null}
                    .
                </EntityActivitySummary>
            </div>
        </div>
    );
};
